var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28571 0H11.2143C11.6879 0 12.1421 0.263392 12.477 0.732233C12.8119 1.20107 13 1.83696 13 2.5C13 3.16304 12.8119 3.79893 12.477 4.26777C12.1421 4.73661 11.6879 5 11.2143 5H2.28571C1.81211 5 1.35791 4.73661 1.02302 4.26777C0.688137 3.79893 0.5 3.16304 0.5 2.5C0.5 1.83696 0.688137 1.20107 1.02302 0.732233C1.35791 0.263392 1.81211 0 2.28571 0ZM14.7857 20H23.7143C24.1879 20 24.6421 20.2634 24.977 20.7322C25.3119 21.2011 25.5 21.837 25.5 22.5C25.5 23.163 25.3119 23.7989 24.977 24.2678C24.6421 24.7366 24.1879 25 23.7143 25H14.7857C14.3121 25 13.8579 24.7366 13.523 24.2678C13.1881 23.7989 13 23.163 13 22.5C13 21.837 13.1881 21.2011 13.523 20.7322C13.8579 20.2634 14.3121 20 14.7857 20ZM2.28571 10H23.7143C24.1879 10 24.6421 10.2634 24.977 10.7322C25.3119 11.2011 25.5 11.837 25.5 12.5C25.5 13.163 25.3119 13.7989 24.977 14.2678C24.6421 14.7366 24.1879 15 23.7143 15H2.28571C1.81211 15 1.35791 14.7366 1.02302 14.2678C0.688137 13.7989 0.5 13.163 0.5 12.5C0.5 11.837 0.688137 11.2011 1.02302 10.7322C1.35791 10.2634 1.81211 10 2.28571 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.65a532f8b1b177a8d8c663572d97cf74.svg";
export { ForwardRef as ReactComponent };